import styles from "./header-action-button.module.css";
import cn from "classnames";
import { forwardRef } from "react";

export const HeaderActionButton = forwardRef<HTMLDivElement, React.ComponentProps<"div"> & { disabled?: boolean }>(
  ({ children, className, disabled, ...props }, ref) => {
    return (
      <div
        className={cn(styles.headerActionButton, className, { [styles.disabled]: disabled })}
        {...props}
        ref={ref}
        data-clicked={undefined}
        onMouseDown={(e) => {
          e.currentTarget.dataset.clicked = "true";
        }}
        onClick={(e) => {
          if (props.onClick) props.onClick(e);
        }}
        onMouseUp={(e) => {
          e.currentTarget.dataset.clicked = "false";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.dataset.clicked = "false";
        }}
      >
        {children}
      </div>
    );
  }
);

HeaderActionButton.displayName = "HeaderActionButton";
